import { defineStore } from 'pinia';
import { useStore } from 'vuex';
import { computed } from 'vue';

export const useProfileBridgeStore = defineStore('profileBridge', () => {
	const vuex = useStore();

	const locale = computed(() => vuex.state.profile.locale);

	const changeLocale = (localeKey: string) => {
		return vuex.dispatch('profile/changeLocale', localeKey);
	};

	return {
		locale,
		changeLocale,
	};
});
